

/* ---------------------------------------------------------------
                    MODULE: LEGEND
-----------------------------------------------------------------*/

/* This function draws a legend.

*/


import { select } from "d3-selection"

export const drawLegendHtml = (legendContainerClass, colorScale, keys) => {

  /*
  This function creates an HTML legend using D3.

  legendContainerClass: Required. String. Class name of div that will hold legend
  colorSCale: Required. d3 func. Determines color of dots and text labels based on keys.
  keys: Required. Array. Keys used for each of our labels. To use colorScale domain, use colorScale.domain()
  */

  // select the legend element
  const legend = select("." + legendContainerClass).append('div').attr('class','legend')

  // Add one dot in the legend for each name.
  const legendLabelGroups = legend.selectAll("legend__labels")
    .data(keys)
    .enter()
    .append("g")
    .attr('class',"legend__labelGroup")

  legendLabelGroups
    .append('div')    
    .style('height', '15px')
    .style('width', '15px')
    .style('border-radius', '50%')
    .style('display', 'block')
    .style('background-color',d => colorScale(d))
    .attr('class','legend__dot')

  legendLabelGroups
    .append('span')    
      .html(d => d)
      .style('color', d => colorScale(d))
      .style('display', 'block')
      .attr('class','legend__label')



  // const legendLabelGroups = legendContainer.selectAll("legend__labelGroup")
  //   .data(keys)
  //   .enter()
  //   .append('div')
  //     .style('height', '15px')
  //     .style('width', '15px')
  //     .style('border-radius', '50%')
  //     .style('display', 'inline-block')
  //     .style('background-color',d => colorScale(d))
    
  //     .append('p')    
  //     .html(d => d)
  //     .style('color', d => colorScale(d))

  // legendContainer.selectAll("legend__dots")
  //   .data(keys)
  //   .enter()
  //   .append("div")
  //   .style('height', '15px')
  //   .style('width', '15px')
  //   .style('border-radius', '50%')
  //   .style('display', 'inline-block')
  //   .style('background-color',d => colorScale(d))

      // height: 25px;
      // width: 25px;
      // background-color: #bbb;
      // border-radius: 50%;
      // display: inline-block;

      // .attr("cx", function(d,i){ return 10 + i*40})
      // .attr("cy", 10) // 100 is where the first dot appears. 25 is the distance between dots
      // .attr("r", 7)
      // .style("fill", d => colorScale(d))

  // Add one dot in the legend for each name.
  // legendContainer.selectAll("mylabels")
  //   .data(keys)
  //   .enter()
  //   .append("text")
  //     .attr("x", function(d,i){ return 20 + i*40})
  //     .attr("y", 10) // 100 is where the first dot appears. 25 is the distance between dots
  //     .style("fill", d => colorScale(d))
  //     .text(d => d)
  //     .attr("text-anchor", "left")
  //     .style("alignment-baseline", "middle")

}